import React, { useEffect } from 'react'
import CryptoJS from "crypto-js";
import { useLocation, useNavigate } from 'react-router-dom';
import { adminLogin } from '../../api/request/adminlogin';
import { setCookies } from '../../services/Cookies';
import { useDispatch } from 'react-redux';
import { setloggedIn, setUserDetails } from '../../store/Slices/userSlice';
import { Spin } from 'antd';

const AdminLogin = () => {
    var key = process.env.REACT_APP_SECRET_KEY;
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const getUser = async (token, id) => {
        try {
            const { data } = await adminLogin(token, { userId: id })
            setCookies('token', data?.data?.access_token);
            dispatch(setloggedIn(true));
            let user = data?.data;
            delete user?.access_token;
            dispatch(setUserDetails(user));
            localStorage.clear('userId');
            navigate("/dashboard");
        } catch (err) { navigate('/') }
    }

    useEffect(() => {
        const encrypted = decodeURIComponent(queryParams.get("token"));

        var decrypted = CryptoJS.AES.decrypt(encrypted, key);
        const data = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
        getUser(data.token, data.user.userId)


    }, [])
    return (
        <>
            <div className='h-screen w-full flex justify-center items-center'>
                <Spin size="large" />
            </div>
        </>
    )
}

export default AdminLogin